import { TFunction } from "i18next";

import { QUERY_KEYS } from "./query-keys";


export const ONE_BANK = 1;

export const TRANSFER_CARD_MODES = {
  MANUAL: 'manual',
  AUTOMATIC: 'automatic',
}

export const TRANSFER_MODES: { [key: string]: 'on_demand' | 'auto_transfer' } = {
  MANUAL: 'on_demand',
  AUTO: 'auto_transfer',
}


export const LOCK_BUTTON_CONFIG = {
  true:  { show: true,  disabled: true },   // locked → show but inactive
  false: { show: true,  disabled: false },  // unlocked → show and active
  null:  { show: false, disabled: false },  // null → hide button
};

export const TRANSFERS_STATUS = (t: TFunction) => ({
  PENDING: {
    color: 'yellow',
    text: t('innerLayout.balancePage.pending'),
  },
  FAILED: {
    color: 'red',
    text: t('innerLayout.balancePage.failed'),
  },
  SUCCESS: {
    color: 'green',
    text: t('innerLayout.balancePage.success'),
  },
})

export const MINIMUM_TRANSFER_AMOUNT = 100;
export const INVALIDATE_DELAY = 2500

export const INSTANT_SETTLEMENT_INVALIDATE_KEYS = [
  QUERY_KEYS.GET_BALANCE_DETAILS,
  QUERY_KEYS.GET_RECENT_TRANSFERS,
];

export const SUCCESS_STATUS_CODE = 200

export const PLACEHOLDER_AMOUNT_FOR_BANK_DETAILS = 1;
export const DEBOUNCE_INPUT_TIME = 800
export const REPORTS_TYPE = {
  ALL_TRANSACTIONS: 'all_transactions',
}